export * from './DetailsEvents.component';
export * from './NoDetailsEvents.component';
